module.exports = __webpack_public_path__ + "static/no-smoking-b5f8f7c6ddadf7e3dc48161077813ef8.svg";